<template>
    
<ul class="assunto-list">
    <li v-for="assunto in assuntos" :key="assunto.id" class="assunto-item">
        <div class="assunto-info row">
            <div class="assunto-content col-8">
                <span @click="toggleVisibility(assunto.id)">
                    <span v-html="pegarSetasHTML(assunto.id)" style="padding: 0px; margin: 0px; vertical-align: middle;"></span>
                    {{ assunto.descricao }}
                </span>
            </div>
            <div class="assunto-actions col-4 text-right" style="text-align: right;">
                <!-- <button @click="emitEditAssunto(assunto)">Editar</button> --> <!-- Edição não implementada -->
                <button @click="emitAddSubassunto(assunto.id, assunto.descricao)" type="button" class="btn btn-sm btn-light" style="margin-left: 5px; width: 130px; background-color: rgb(235, 234, 234); cursor: pointer; font-size: 12px; padding: 1px;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">add</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Criar subassunto</label>
                </button>
                <button @click="emitDeleteAssunto(assunto.id)" type="button" class="btn btn-sm btn-light" style="margin-left: 5px; width: 130px; background-color: rgb(235, 234, 234); cursor: pointer; font-size: 12px; padding: 1px;">
                    <span class="material-icons" style="vertical-align: middle; color: #007BFF;">delete</span> 
                    <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Deletar</label>
                </button>
            </div>
        </div>
        <!-- Renderizar subassuntos se existirem -->
        <AssuntoTree v-if="isVisible(assunto.id) && assunto.children && assunto.children.length" 
        :assuntos="assunto.children" @addSubassunto="emitAddSubassunto" @editAssunto="emitEditAssunto" @deleteAssunto="emitDeleteAssunto" />
    </li>
</ul>  


</template>
  
<script>
import { ref } from 'vue';

export default {
    name: 'AssuntoTree',
    data() {
        return {
            visibleStates: {},
        };
        
    },
    props: {
        assuntos: Array,
    },
    setup(props) {
        const visibleStates = ref({});

        function toggleVisibility(id) {
            if (visibleStates.value[id] === undefined) {
                visibleStates.value[id] = true;
            } else {
                visibleStates.value[id] = !visibleStates.value[id];
            }
        }

        function isVisible(id) {
            return !!visibleStates.value[id];
        }
        return { toggleVisibility, isVisible };
    },

    methods: {
        emitAddSubassunto(parentId, label_descricao) {
            this.$emit('addSubassunto', parentId, label_descricao);
        },
        emitEditAssunto(assunto) {
            this.$emit('editAssunto', assunto);
        },
        emitDeleteAssunto(assuntoId) {
            this.$emit('deleteAssunto', assuntoId);
        },

        pegarSetasHTML(id) {
            return this.isVisible(id) 
                ? '<span class="material-icons">expand_more</span>' 
                : '<span class="material-icons">chevron_right</span>';
        }

    },
    mounted(){
        
    }

};
</script>
  
<style scoped>
.assunto-list {
    list-style-type: none;
}

.assunto-item {

}

.assunto-item:hover{
    background-color: #f0f0f0; /* Cinza leve para ao passar o mouse na macro área */
}


.assunto-info {
    padding: 2px;
    margin: 2px;
}

.assunto-info:hover {
    background-color: #e0e0e0; /* Cinza mais forte ao passar o mouse em casa item */
    cursor: pointer;
}
</style>
